<script lang="ts" context="module">
  /**
   * Type Export
   * ---------------------------------------------------------------------------
   */

  export type CardImageAspectRatio = "landscape" | "landscape43" | "square";
</script>

<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import { twMerge } from "tailwind-merge";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  /** image URL */
  export let imageSrc: string | undefined = undefined;

  /** image aspect ratio */
  export let imageAspectRatio: CardImageAspectRatio = "landscape";

  /** mobile image aspect ratio */
  export let imageAspectRatioMobile: CardImageAspectRatio = "landscape";

  /** image alt text */
  export let altText: string = "";

  /** true to display the image as disabled */
  export let isDisabled: boolean = false;

  /** extra classes for the image element */
  export let imageClass: string = "";

  /**
   * Data / State
   * ---------------------------------------------------------------------------
   */

  const aspectRatios: {
    [key in CardImageAspectRatio]: string;
  } = {
    landscape: "sm:aspect-video", // 16:9
    landscape43: "sm:aspect-[4/3]", // 4:3
    square: "sm:aspect-square", // 1:1
  };

  const aspectRatiosMobile: {
    [key in CardImageAspectRatio]: string;
  } = {
    landscape: "aspect-video", // 16:9
    landscape43: "aspect-[4/3]", // 4:3
    square: "aspect-square", // 1:1
  };
</script>

<!-- Template ----------------------------------------------------------------->

{#if !!imageSrc}
  <div class={twMerge("w-full", isDisabled && "opacity-50", $$props.class)}>
    <img
      loading="lazy"
      class={twMerge(
        "object-cover",
        aspectRatios[imageAspectRatio],
        aspectRatiosMobile[imageAspectRatioMobile],
        imageClass,
      )}
      alt={altText}
      src={imageSrc}
    />
  </div>
{/if}
